import { LiteTextEditor } from "shared/app/Editor/LiteTextEditor";
import { cx } from "shared/utils";

interface NoteDisplayProps {
  note: string;
  containerClassName?: string;
}

export const NoteDisplay = ({ note, containerClassName }: NoteDisplayProps) => {
  return (
    <LiteTextEditor
      editable={false}
      initialValue={note}
      id="activity-note"
      containerClassName={cx("text-content-400 text-sm", containerClassName)}
    />
  );
};
